import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, mergeMap } from 'rxjs/operators'

import { combineEpicsIsolated } from 'utils/epicRegistry'

import { addToast } from 'containers/Toasts/actions'

import { FETCH_DMARC_INFO_REQUEST, SUBMIT_DMARC_INFO_REQUEST } from './constants'

const fetchDmarcInfoEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_DMARC_INFO_REQUEST.INITIATE),
    mergeMap(() =>
      api.settings.getDmarcRequestInfo().pipe(
        mergeMap((response) =>
          of(
            FETCH_DMARC_INFO_REQUEST.onSuccess({
              userRequestedDmarcInfo: response.dmarc_request_info,
            })
          )
        ),
        catchError((error) => of(epicsErrorHandler(FETCH_DMARC_INFO_REQUEST.onError, error)))
      )
    )
  )

const submitDmarcInfoEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(SUBMIT_DMARC_INFO_REQUEST.INITIATE),
    mergeMap(() =>
      api.settings.postDmarcRequestInfo().pipe(
        mergeMap((response) =>
          of(
            SUBMIT_DMARC_INFO_REQUEST.onSuccess({
              userRequestedDmarcInfo: response.response.dmarc_request_info,
            }),
            addToast({
              message:
                'Your inquiry has been successfully submitted. Our team will reach out to you shortly.',
              type: 'success',
            })
          )
        ),
        catchError((error) =>
          of(
            epicsErrorHandler(SUBMIT_DMARC_INFO_REQUEST.onError, error),
            addToast({
              message: error.response?.message || 'Failed to submit DMARC info request',
              type: 'error',
            })
          )
        )
      )
    )
  )

export default combineEpicsIsolated(fetchDmarcInfoEpic, submitDmarcInfoEpic)
